export { AboutTab } from './AboutTab/AboutTab'
export { CommunityTab } from './CommunityTab/CommunityTab'
export { SuggestedTab } from './SuggestedTab/SuggestedTab'
export { CollectionTab } from './CollectionTab/CollectionTab'
export { WatchEpisodesTab } from './WatchEpisodesTab/WatchEpisodesTab'
export { ExtrasTab } from './ExtrasTab/ExtrasTab'
